module.exports = __webpack_public_path__ + "static/img/6.e1159ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/sp/6.png
// module id = RN92
// module chunks = 0